const siteName = 'GamerHub';
const siteDescription = `Your competitive edge. Up to date game wikis, tier lists, and patch notes for the games you love. Create and share tier lists for the lols, or the win.`;
const siteKeywords = [
  'Tier List',
  'Guides',
  'Meta',
  'Balance',
  'Tiers',
  'Items',
  'Heroes',
  'Weapons',
  'Synergies',
  'Cheat Sheet',
  'Comp',
  'Build',
  'Top'
];

const TierListToText = (tierList, entityLimitPerRow) => {
  let resultString = '';
  for (let x = 0; x < tierList.length; x += 1) {
    let entitiesIncludedInTextTier = 0;
    const tier = tierList[x];
    // Only include tier if it has at least one character
    if (tier.characters.length !== 0) {
      resultString += `${tier.name} Tier: `;

      for (let y = 0; y < tier.characters.length; y += 1) {
        const entity = tier.characters[y];
        resultString += entity.name + (y < tier.characters.length - 1 ? ', ' : '');
        entitiesIncludedInTextTier += 1;
        if (entitiesIncludedInTextTier >= entityLimitPerRow) {
          const remainingEntitiesInTier = tier.characters.length - 1 - y;
          if (remainingEntitiesInTier) {
            resultString += `and ${tier.characters.length - 1 - y} more`;
          }
          break;
        }
      }

      if (x < tierList.length - 1) {
        resultString += ' | ';
      }
    }
  }
  return resultString;
};

const GenerateTierListDescription = ({ tierList, ugcDescription }) => {
  if (tierList === undefined) return;
  return `${ugcDescription} | ${TierListToText(tierList, 3)}`;
};

const GetRandomDefaultTitle = ({ entityTermPlural }) => {
  const term = entityTermPlural || 'Characters';
  const options = [
    `Top ${term} To Pick`,
    `${term} Ranked`,
    `Best and Worst ${term}`,
    `Top Tier ${term}`,
    `${term} by Tier`
  ];

  const optionIndex = Math.floor(Math.random() * options.length);
  return options[optionIndex];
};

const GenerateTierListKeywords = ({ characters }) => {
  const characterKeywords = characters && characters.map(character => character.name);
  const result = characterKeywords && characterKeywords.concat(siteKeywords);
  return result && result.join(',');
};

module.exports = {
  GenerateTierListDescription,
  GenerateTierListKeywords,
  GetRandomDefaultTitle,
  siteDescription,
  siteName,
  siteKeywords
};
